import React from 'react'
import './loading.css'

export const Loading = () => {
  return (
   
    <div className='contenedorLoading' >
    <div className="lds-facebook"><div></div><div></div><div></div></div>
    
    </div>





  )
}
